import { Component, Output, ViewChild, EventEmitter, AfterViewChecked, Input } from '@angular/core';

declare var jQuery: any;

@Component({
  selector: 'ch-cancel-subscription-modal-dialog',
  templateUrl: './cancel-subscription-modal-dialog.component.html',
})
export class CancelSubscriptionModalDialogComponent implements AfterViewChecked {
  @Input() public show = true;
  @Input() public showEndOfPeriod = true;
  @Output() public onClose: EventEmitter<any> = new EventEmitter();
  @Output() public onSubmitImmediateCancellation: EventEmitter<any> = new EventEmitter<any>();
  @Output() public onSubmitEndOfPeriodCancellation: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('modal') private modal;
  loading = true;

  ngAfterViewChecked() {
    if (!this.show) {
      return;
    }
    jQuery(this.modal.nativeElement)
      .modal({
        backdrop: false,
      })
      .on('hidden.bs.modal', e => {
        this.onClose.emit(e);
      });
  }

  submitImmediateCacellation(): void {
    this.onSubmitImmediateCancellation.emit();
    this.closeDialog();
  }

  submitEndOfPeriodCacellation(): void {
    this.onSubmitEndOfPeriodCancellation.emit();
    this.closeDialog();
  }

  private closeDialog() {
    jQuery(this.modal.nativeElement).modal('hide');
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/member/cancel-subscription-modal-dialog/cancel-subscription-modal-dialog.component.ts